import { render, staticRenderFns } from "./RemarkListCard.vue?vue&type=template&id=2f6e1fc3&scoped=true&"
import script from "./RemarkListCard.vue?vue&type=script&lang=js&"
export * from "./RemarkListCard.vue?vue&type=script&lang=js&"
import style0 from "./RemarkListCard.vue?vue&type=style&index=0&id=2f6e1fc3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e1fc3",
  null
  
)

export default component.exports